/* URSO - Seletor de variante no card de produto.
   Cobre os dois tipos de card do tema:
   1) card de grade (snippets/product-card.liquid) - pilulas renderizadas no Liquid
   2) card destaque (snippets/product-card-featured.liquid) - pilulas injetadas aqui,
      com os dados vindos de /products/<handle>.js
   Em ambos, o clique troca a variante enviada ao carrinho, o preco, o Pix,
   o parcelamento, o selo de desconto e a imagem. */
(function () {
  'use strict';
  if (window.ursoCardVariantsInit) return;
  window.ursoCardVariantsInit = true;

  /* ---------------- utilitarios ---------------- */
  function toCents(txt) {
    var d = (txt || '').replace(/[^0-9]/g, '');
    return parseInt(d, 10) || 0;
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    var i = v[0];
    var out = '';
    for (var k = 0; k < i.length; k++) {
      out += i.charAt(k);
      var rem = i.length - 1 - k;
      if (rem > 0 && rem % 3 === 0) out += '.';
    }
    return 'R$ ' + out + ',' + v[1];
  }

  function setImage(scope, url) {
    if (!url) return;
    var img = scope.querySelector('.card-wrapper__media img.media--first') ||
              scope.querySelector('.card-wrapper__media img') ||
              scope.querySelector('.urso-card__media img');
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
  }

  /* ---------------- arrastar para rolar (mouse) ---------------- */
  function enableDragScroll(row) {
    if (!row || row.dataset.dragscroll === '1') return;
    row.dataset.dragscroll = '1';

    var down = false, moved = false, startX = 0, startLeft = 0, pid = null;

    row.addEventListener('pointerdown', function (e) {
      row.removeAttribute('data-dragged');
      if (e.pointerType === 'touch') return;
      if (typeof e.button === 'number' && e.button !== 0) return;
      down = true;
      moved = false;
      pid = e.pointerId;
      startX = e.clientX;
      startLeft = row.scrollLeft;
    });

    row.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved) {
        if (Math.abs(dx) < 4) return;
        moved = true;
        row.classList.add('is-grabbing');
        try { row.setPointerCapture(pid); } catch (err) {}
      }
      row.scrollLeft = startLeft - dx;
      e.preventDefault();
    });

    function endDrag() {
      if (!down) return;
      down = false;
      if (moved) row.dataset.dragged = '1';
      moved = false;
      row.classList.remove('is-grabbing');
      try { row.releasePointerCapture(pid); } catch (err) {}
    }

    row.addEventListener('pointerup', endDrag);
    row.addEventListener('pointercancel', endDrag);
    row.addEventListener('lostpointercapture', endDrag);
    row.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------------- card de grade ---------------- */
  function applyGrid(card, btn) {
    var d = btn.dataset;

    var input = card.querySelector('.urso-card__addform [name="id"]');
    if (input && d.vid) input.value = d.vid;

    var priceEl = card.querySelector('.price-item--sale') ||
                  card.querySelector('.price__regular .price-item--regular');
    if (priceEl && d.price) priceEl.textContent = d.price;

    var capEl = card.querySelector('.price__compare');
    if (capEl) {
      var capItem = capEl.querySelector('.price-item');
      if (d.cap) {
        if (capItem) capItem.textContent = d.cap;
        capEl.style.display = '';
      } else {
        capEl.style.display = 'none';
      }
    }

    var pix = card.querySelector('.urso-price-pix');
    if (pix && d.pixtext) pix.textContent = d.pixtext;

    var inst = card.querySelector('.urso-price-installments');
    if (inst && d.insttext) inst.textContent = d.insttext;

    var badge = card.querySelector('.discount-badge');
    if (badge) {
      var txt = badge.querySelector('.discount-text');
      if (txt && txt.textContent.indexOf('%') >= 0) {
        if (d.off && d.off !== '0') {
          txt.textContent = '-' + d.off + '%';
          badge.style.display = '';
        } else {
          badge.style.display = 'none';
        }
      }
    }

    setImage(card, d.img);

    var sold = d.av === 'false';
    var addBtn = card.querySelector('.urso-card__addform button[type="submit"]');
    if (addBtn) {
      addBtn.disabled = sold;
      addBtn.classList.toggle('urso-btn--disabled', sold);
    }
    var addForm = card.querySelector('.urso-card__addform');
    var aviseBtn = card.querySelector('.urso-avise-open');
    var esgotado = card.querySelector('.urso-card__esgotado');
    if (addForm && aviseBtn) {
      addForm.style.display = sold ? 'none' : '';
      aviseBtn.style.display = sold ? '' : 'none';
    }
    if (esgotado) esgotado.style.display = sold ? '' : 'none';
  }

  /* ---------------- card destaque ---------------- */
  function applyFeatured(card, btn) {
    var d = btn.dataset;

    var input = card.querySelector('form [name="id"]');
    if (input && d.vid) input.value = d.vid;

    var priceEl = card.querySelector('.urso-card__price');
    if (priceEl && d.price) priceEl.textContent = d.price;

    var capEl = card.querySelector('.urso-card__compare');
    if (capEl) {
      if (d.cap) { capEl.textContent = d.cap; capEl.style.display = ''; }
      else { capEl.style.display = 'none'; }
    }

    var pixEl = card.querySelector('.urso-card__pix');
    if (pixEl && d.pixtext) pixEl.textContent = d.pixtext;

    var instEl = card.querySelector('.urso-card__installments');
    if (instEl && d.insttext) instEl.textContent = d.insttext;

    setImage(card, d.img);

    var addBtn = card.querySelector('form button[type="submit"]');
    if (addBtn) {
      var sold = d.av === 'false';
      addBtn.disabled = sold;
      addBtn.classList.toggle('urso-card__button--disabled', sold);
    }
  }

  var cache = {};

  function buildFeatured(card, data) {
    if (!data || !data.variants || data.variants.length < 2) return;
    var content = card.querySelector('.urso-card__content');
    var priceBlock = card.querySelector('.urso-card__price-block');
    if (!content || !priceBlock) return;
    if (card.querySelector('.urso-card__variants')) return;

    var seen = {};
    var picks = [];
    data.variants.forEach(function (v) {
      var val = v.options && v.options[0];
      if (!val || seen[val]) return;
      seen[val] = true;
      picks.push({ val: val, v: v });
    });
    if (picks.length < 2) return;

    var basePrice = toCents((card.querySelector('.urso-card__price') || {}).textContent);
    var basePix = toCents((card.querySelector('.urso-card__pix') || {}).textContent);
    var instTxt = (card.querySelector('.urso-card__installments') || {}).textContent || '';
    var instCount = parseInt((instTxt.replace(/[^0-9x]/g, '').split('x')[0] || '0'), 10) || 0;
    var pixRatio = (basePrice > 0 && basePix > 0) ? (basePix / basePrice) : 0;
    var pixSuffix = ((card.querySelector('.urso-card__pix') || {}).textContent || '').split(' no ');
    pixSuffix = pixSuffix.length > 1 ? (' no ' + pixSuffix.slice(1).join(' no ')) : ' no Pix';

    var current = (card.querySelector('form [name="id"]') || {}).value;
    var row = document.createElement('div');
    row.className = 'urso-card__variants';
    row.setAttribute('data-urso-card-variants', '');

    picks.slice(0, 8).forEach(function (p) {
      var v = p.v;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'urso-card__variant' + (String(v.id) === String(current) ? ' is-active' : '');
      b.setAttribute('aria-label', p.val);
      b.dataset.vid = v.id;
      b.dataset.price = money(v.price);
      b.dataset.cap = (v.compare_at_price && v.compare_at_price > v.price) ? money(v.compare_at_price) : '';
      b.dataset.av = v.available ? 'true' : 'false';
      if (pixRatio > 0) b.dataset.pixtext = money(Math.round(v.price * pixRatio)) + pixSuffix;
      if (instCount > 1) b.dataset.insttext = instCount + 'x de ' + money(Math.round(v.price / instCount));
      if (v.featured_image && v.featured_image.src) b.dataset.img = v.featured_image.src;

      var dot = document.createElement('span');
      dot.className = 'urso-card__variant-dot';
      if (v.featured_image && v.featured_image.src) {
        dot.style.backgroundImage = 'url(' + v.featured_image.src + ')';
        dot.style.backgroundSize = 'cover';
        dot.style.backgroundPosition = 'center';
      }
      var lab = document.createElement('span');
      lab.className = 'urso-card__variant-lab';
      lab.textContent = p.val;
      b.appendChild(dot);
      b.appendChild(lab);
      row.appendChild(b);
    });

    content.insertBefore(row, priceBlock);
    enableDragScroll(row);
  }

  function enhanceFeatured(card) {
    if (card.dataset.ursoVar) return;
    var link = card.querySelector('a[href*="/products/"]');
    var form = card.querySelector('form[action*="/cart/add"]');
    if (!link || !form || !form.querySelector('[name="id"]')) return;
    var tail = (link.getAttribute('href') || '').split('/products/')[1];
    if (!tail) return;
    var handle = tail.split('?')[0].split('#')[0];
    card.dataset.ursoVar = '1';
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    cache[handle].then(function (data) { buildFeatured(card, data); }).catch(function () {});
  }

  function boot() {
    document.querySelectorAll('.urso-card').forEach(enhanceFeatured);
    document.querySelectorAll('.urso-card__variants').forEach(enableDragScroll);
  }

  /* ---------------- clique ---------------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.urso-card__variant');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.urso-card__variants');
    if (wrap && wrap.dataset.dragged) {
      wrap.removeAttribute('data-dragged');
      return;
    }
    if (wrap) {
      wrap.querySelectorAll('.urso-card__variant').forEach(function (x) {
        x.classList.remove('is-active');
      });
    }
    btn.classList.add('is-active');
    var grid = btn.closest('.card-wrapper');
    if (grid) { applyGrid(grid, btn); return; }
    var feat = btn.closest('.urso-card');
    if (feat) applyFeatured(feat, btn);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('load', boot);
})();